import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RegionState {
  selectedRegion: any | null;
}

const initialState: RegionState = {
  selectedRegion: null,
};

const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {
    setSelectedRegionData: (state, action: PayloadAction<any | null>) => {
      state.selectedRegion = action.payload;
    },
  },
});

export const { setSelectedRegionData } = regionSlice.actions;
export default regionSlice.reducer;
